import { FC, MouseEvent } from 'react'
import { CheckIcon } from 'lucide-react'
import { setLesson, useAppDispatch, useAppSelector } from '../../../redux'
import { LessonType } from '../../../types'
import { ROUTES, formatVideoLength, useCourse } from '../../../utils'
import { StyledLessonSidebarLesson } from '.'

type Props = {
  lesson: LessonType
}

const LessonSidebarLesson: FC<Props> = ({ lesson }) => {
  const dispatch = useAppDispatch()
  const { toggleLessonComplete } = useCourse()
  const { course, lesson: l } = useAppSelector((state) => state.course)
  const COMPLETED = lesson.isCompleted
  const CURRENT = lesson._id === l?._id

  const handleComplete = async (e: MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()

    await toggleLessonComplete(lesson)
  }

  return (
    <StyledLessonSidebarLesson
      to={ROUTES.course.byLesson(course?.slug || '', lesson.slug)}
      $completed={COMPLETED}
      $current={CURRENT}
      onClick={() => dispatch(setLesson(lesson))}
    >
      <div className="lesson-status">
        <button className="lesson-status-btn" onClick={(e) => handleComplete(e)}>
          {COMPLETED && !CURRENT && <CheckIcon />}
        </button>
      </div>
      <span className="lesson-title">{lesson.title}</span>
      <span className="lesson-length">{formatVideoLength(lesson.video?.duration || 0)}</span>
    </StyledLessonSidebarLesson>
  )
}

export default LessonSidebarLesson
